import { render, staticRenderFns } from "./NotesFormatter.vue?vue&type=template&id=85d54762&scoped=true&"
import script from "./NotesFormatter.vue?vue&type=script&lang=js&"
export * from "./NotesFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d54762",
  null
  
)

export default component.exports